import { createSelector } from 'reselect';

import { __getCommonData } from '../../selectors';

/** Base Data selector, all the other selectors must use it */
const getBasketSettings = (state) => __getCommonData(state).basket;

export const getBasketContentCookieName = (state) => getBasketSettings(state).contentCookieName;
export const getBasketCreditCookieName = (state) => getBasketSettings(state).creditCookieName;
export const getBasketUrl = () => '/basket';
export const getBasketMaxQuantity = (state) => getBasketSettings(state).maxQuantity;
export const getBasketCookiePath = (state) => getBasketSettings(state).contentCookiePath;
export const getBasketLoading = (state) => getBasketSettings(state).loading;
export const getBasketData = (state) => getBasketSettings(state).basketData || [];
export const isBasketDataFetchedSelector = (state) => getBasketSettings(state).isBasketDataFetched;

export const getBodyData = (state) => state.body;
export const getMainCollectionId = (state) => getBodyData(state).mainCollectionId;

/** returns basket contents */
export const getBasketContents = createSelector(getBasketContentCookieName, (name) => {
  const storage = (window || {}).localStorage;
  const basketContents = storage.getItem(name);
  if (basketContents) {
    return JSON.parse(basketContents);
  }
  return { items: [], fancynumbers: [] };
});

export const getBasketItems = createSelector(getBasketData, (data) =>
  data.map((item) => ({
    id: item.id,
    itemId: item?.itemId,
    isPreorder: item.isPreorder,
    isExcluded: item.isExcluded,
  })),
);

export const getIsItemInBasket = (state, productId) => {
  const basketItems = getBasketItems(state);
  return basketItems?.find(
    (item) => item?.id?.toString() === productId?.toString() && !item?.isExcluded,
  );
};

export const selectIsPreorderItemInBasketAndExcluded = (state, productId) => {
  const basketItems = getBasketItems(state);
  return basketItems?.find(
    (item) =>
      item?.id?.toString() === productId?.toString() && item?.isExcluded && item?.isPreorder,
  );
};

export const selectItemIdFromId = (state, productId) => {
  const basketItems = getBasketItems(state);
  return basketItems?.find((item) => item?.id?.toString() === productId?.toString())?.itemId;
};

export const getIsBundleInBasket = (state, bundleId) => {
  const basketItems = getBasketData(state);
  return basketItems?.find(
    (item) =>
      item?.details?.promotionId &&
      item?.details?.promotionId?.toString() === bundleId?.toString() &&
      !item?.isExcluded,
  );
};

export const getBasketProductIds = createSelector(getBasketItems, (items) =>
  items.map((item) => item.id),
);
